const list = {
  path: 'labelList',
  component: resolve => require(['@/pages/admin/platform/message/labelList'], resolve)
}

export default list
